import { IEntityFilter, IFilter } from "../../../../context/filters";
import { ISelectedFilterGroup, ISelectedFilterMap } from "../../../../context/selectedFilters";
import { buildUrlFromSelectedFilters } from "./buildUrl";
import { isFilterSelected } from "./isFilterSelected";

const addToSelectedMap = (
  entityFilter: IEntityFilter,
  filter: IFilter,
  selectedFilterMap: ISelectedFilterGroup
): ISelectedFilterGroup => ({
  ...selectedFilterMap,
  [entityFilter.entity.slug]: { entityFilter, filter }
});

const removeFromSelectedMap = (
  entityFilter: IEntityFilter,
  selectedFilterMap: ISelectedFilterGroup
): ISelectedFilterGroup => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { [entityFilter.entity.slug]: entitySlug, ...rest } = selectedFilterMap;
  return rest;
};

export const toggleFromSelectedMap = (
  entityFilter: IEntityFilter,
  filter: IFilter,
  selectedFilterMap: ISelectedFilterMap
): ISelectedFilterMap => {
  const { featured, secondary } = selectedFilterMap;
  const isFeatured = entityFilter.featured;
  const toggleGroup = isFeatured ? featured : secondary;
  const isSelected = isFilterSelected(selectedFilterMap, entityFilter, filter);
  const resultGroup = isSelected
    ? removeFromSelectedMap(entityFilter, toggleGroup)
    : addToSelectedMap(entityFilter, filter, toggleGroup);
  return isFeatured ? { featured: resultGroup, secondary } : { featured, secondary: resultGroup };
};

export const toggleFilterFromUrl = (
  selectedFilterMap: ISelectedFilterMap,
  entityFilter: IEntityFilter,
  filter: IFilter
) => {
  const resultMap = toggleFromSelectedMap(entityFilter, filter, selectedFilterMap);
  return buildUrlFromSelectedFilters(resultMap);
};
